import { Affiliate } from "./affiliate.types";
import { User, UserRole, UserStatus } from "./user.types";

export enum ReferralPaymentStatus {
  PAID = "paid",
  UNPAID = "unpaid",
}

export type Referral = Pick<
  User,
  "id" | "profileImage" | "firstName" | "lastName" | "role" | "status"
> & {
  paymentStatus: ReferralPaymentStatus;
  invitesCount?: number;
  invitesCountByRole?: Record<UserRole, Record<UserStatus, number>>;
  affiliate?: Affiliate;
};
